import { NotificationSettings } from '../components/notification-settings.js';

// Settings of this browser. The monthly cost threshold is set per server, on the server page.

export function Settings() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold" style={{ color: 'var(--color-text)' }}>Settings</h1>
        <p className="mt-1 text-sm" style={{ color: 'var(--color-text-2)' }}>
          Preferences of this browser. Each server&apos;s monthly cost threshold is on its own page.
        </p>
      </div>
      <NotificationSettings />
    </div>
  );
}
